export default __webpack_public_path__ + "static/media/illustration_step2_howItWorks.d04b4b82.png";